/**
 * Formats a count into a compact string with k/M suffixes for readability
 * in tight UI surfaces like sidebar nav items and page headers.
 *
 * Truncates (rather than rounds) so the displayed value never overstates
 * the underlying count. One decimal is shown only when the magnitude is
 * < 10 (e.g., 1.2k) to keep the result short.
 */
export function formatCount(count: number): string {
  if (count < 1000) return String(count);
  if (count < 1_000_000) return `${truncateToCompact(count / 1000)}k`;
  return `${truncateToCompact(count / 1_000_000)}M`;
}

function truncateToCompact(value: number): string {
  if (value >= 10) return String(Math.floor(value));
  return String(Math.floor(value * 10) / 10);
}
